import { render, staticRenderFns } from "./MaintenanceViewHistory.vue?vue&type=template&id=154d3a69"
import script from "./MaintenanceViewHistory.vue?vue&type=script&lang=js"
export * from "./MaintenanceViewHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports